module.exports = __webpack_public_path__ + "static/media/parceiro(10).aa4017d0.png";